import axiosInstance from "../api/axios";
import { ILoginFormData } from "../types/auth";

export const login = async (data: ILoginFormData) => {
  try {
    const response = await axiosInstance.post(`/auth/login`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.message ||
        "Something went wrong",
    };
  }
};
